import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button, Table, Form, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Fancybox from "../../Component/FancyBox";
import Switch from "react-switch";
import { API } from "../../App";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import Pagination from "rc-pagination";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { useCallback } from "react";

const Wallpaper = () => {
  const [wallpaperData, setWallpaperData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [current, setCurrent] = useState(1);
  const [iconcoror, Seticoncoror] = useState("name_up");
  const [perPage] = useState(10);
  const [size, setSize] = useState(perPage);
  const [search, setSearch] = useState({
    wallpaper_name: "",
    premium: "",
    status: "",
  });
  const handleGetWallpaperData = useCallback(async () => {
    setLoading(true);
    const token = Cookies.get("jwt");
    const res = await API.post(
      "/wallpapersData",
      {},
      { headers: { authorization: `Bearer ${token}` } },
    );
    if (res.data.response_code === 0) {
      navigate("/");
      setLoading(false);
    } else {
      setWallpaperData(res.data.data);
      setLoading(false);
    }
  }, [navigate]);

  const change = async (id, e, name, ind) => {
    const Status = e === true ? true : false;
    toast.success("Update Data successfully", {
      position: "bottom-right",
      autoClose: 500,
    });
    const data1 = [...wallpaperData];
    if (name === "status") {
      data1[ind].status = Status;
    } else {
      data1[ind].premium = Status;
    }
    setWallpaperData(data1);

    const Form = new FormData();
    Form.append("id", id);
    Form.append("name", name);
    Form.append("Status", Status);

    await API.post("/wallpaperUpdateStatus", Form);
    handleGetWallpaperData();
  };

  const handleSearchData = async (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });

    const res = await API.post(`/wallpaperSearchData`, {
      wallpaper_name:
        e.target.name === "wallpaper_name"
          ? e.target.value
          : search.wallpaper_name,
      premium: e.target.name === "premium" ? e.target.value : search.premium,
      status: e.target.name === "status" ? e.target.value : search.status,
    });
    setWallpaperData(res.data.data || []);
  };

  const deleteWallpaper = async (_id) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger me-3",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          await API.post(`/wallpapersDel/${_id}`);
          handleGetWallpaperData();
        }
      });
  };

  const getData = (current, pageSize) => {
    return wallpaperData.slice((current - 1) * pageSize, current * pageSize);
  };

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return <button className="paggination-btn">Previous</button>;
    }
    if (type === "next") {
      return <button className="paggination-btn">Next</button>;
    }
    return originalElement;
  };

  const sorting = (col, order, e) => {
    Seticoncoror(e.target.id);
    if (order === "ASC") {
      const sorted = [...wallpaperData].sort((a, b) =>
        col === "status" || col === "premium"
          ? a[col] === b[col]
            ? 1
            : -1
          : a[col] > b[col]
            ? 1
            : -1,
      );
      if (iconcoror !== e.target.id) setWallpaperData(sorted);
    }
    if (order === "DSC") {
      const sorted = [...wallpaperData].sort((a, b) =>
        col === "status" || col === "premium"
          ? a[col] === b[col]
            ? 1
            : -1
          : a[col] < b[col]
            ? 1
            : -1,
      );
      if (iconcoror !== e.target.id) setWallpaperData(sorted);
    }
  };

  const handleDragEnd = async (e) => {
    if (!e.destination) return;
    let tempData = Array.from(wallpaperData);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setWallpaperData(tempData);
    const arr = [];
    tempData.forEach((val, index) => {
      arr.push({ id: val._id, sort_order: index + 1 });
    });

    const result = await API.post("/wallpaperUpdateIndex", arr);
    if (result.data.response_code === 1) {
      toast.success(result.data.response_message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
        closeOnClick: true,
      });
      handleGetWallpaperData();
    } else {
      toast.error(result.data.response_message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
        closeOnClick: true,
      });
    }
  };

  useEffect(() => {
    handleGetWallpaperData();
  }, [handleGetWallpaperData]);

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1">Wallpaper</h3>
        <Row className="align-items-center">
          <Col md="auto" xs={12}>
            <Form.Control
              type="text"
              name="wallpaper_name"
              placeholder="Search Name"
              className="my-1"
              onChange={handleSearchData}
            />
          </Col>
          <Col md="auto" xs={12}>
            <Form.Select
              className="my-1"
              name="premium"
              onChange={handleSearchData}
            >
              <option value="">Select Premium</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </Form.Select>
          </Col>
          <Col md="auto" xs={12}>
            <Form.Select
              className="my-1"
              name="status"
              onChange={handleSearchData}
            >
              <option value="">Select Status</option>
              <option value={true}>On</option>
              <option value={false}>Off</option>
            </Form.Select>
          </Col>
          <Col md="auto" xs={6}>
            <Form.Select
              className="my-1"
              onChange={(e) => {
                setSize(Number(e.target.value));
                setCurrent(1);
              }}
            >
              {[10, 25, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md="auto" xs={12}>
            <Link to="/wallpaper/add">
              <Button variant="primary" className="my-1" value="create">
                Add New
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="page-content">
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Body>
                <DragDropContext onDragEnd={handleDragEnd}>
                  {loading && <div className="loader table-loader" />}
                  <Table bordered responsive id="myTable">
                    <thead>
                      <tr>
                        <th width="5%" className="text-center">
                          No
                        </th>
                        <th width="25%">
                          <div className="table-sort-filter">
                            Name
                            {wallpaperData.length > 1 ? (
                              <span className="table-sort">
                                <div
                                  className={`sort-down ${
                                    iconcoror === "name_up" ? "active" : ""
                                  }`}
                                  id="name_up"
                                  onClick={(e) => {
                                    sorting("wallpaper_name", "ASC", e);
                                  }}
                                ></div>
                                <div
                                  className={`sort-up ${
                                    iconcoror === "name_down" ? "active" : ""
                                  }`}
                                  id="name_down"
                                  onClick={(e) => {
                                    sorting("wallpaper_name", "DSC", e);
                                  }}
                                ></div>
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </th>
                        <th width="12%" className="text-center">
                          Thumbnail
                        </th>
                        <th width="12%" className="text-center">
                          Wallpaper
                        </th>
                        <th width="14%" className="text-center">
                          Premium
                        </th>
                        <th width="14%" className="text-center">
                          Status
                        </th>
                        <th width="14%" className="text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <Droppable droppableId="droppable-1">
                      {(provider) => (
                        <tbody
                          ref={provider.innerRef}
                          {...provider.droppableProps}
                        >
                          {getData(current, size).map((val, id) => (
                            <Draggable
                              key={val._id}
                              draggableId={val._id}
                              index={id}
                            >
                              {(provider) => (
                                <tr
                                  key={id}
                                  {...provider.draggableProps}
                                  ref={provider.innerRef}
                                  {...provider.dragHandleProps}
                                >
                                  <td className="text-center">{id + 1}</td>
                                  <td>{val.wallpaper_name}</td>
                                  <td className="text-center">
                                    <Fancybox>
                                      {val.thumbnail_url ? (
                                        <a
                                          data-fancybox="thumb-image"
                                          href={val.thumbnail_url}
                                        >
                                          <img
                                            src={val.thumbnail_url}
                                            className="hv-40 bg-light"
                                            alt="Thumbnail"
                                          />
                                        </a>
                                      ) : (
                                        ""
                                      )}
                                    </Fancybox>
                                  </td>
                                  <td className="text-center">
                                    <Fancybox>
                                      {val.wallpaper_url ? (
                                        <a
                                          data-fancybox="wallpaper-image"
                                          href={val.wallpaper_url}
                                        >
                                          <img
                                            src={val.wallpaper_url}
                                            className="hv-40 bg-light"
                                            alt="Wallpaper"
                                          />
                                        </a>
                                      ) : (
                                        ""
                                      )}
                                    </Fancybox>
                                  </td>
                                  <td className="text-center">
                                    <Switch
                                      onChange={(e) => {
                                        change(val._id, e, "premium", id);
                                      }}
                                      checked={val.premium === true}
                                      offColor="#C8C8C8"
                                      onColor="#0093ed"
                                      height={30}
                                      width={70}
                                      className="react-switch"
                                      uncheckedIcon={
                                        <div className="react-switch-off">
                                          NO
                                        </div>
                                      }
                                      checkedIcon={
                                        <div className="react-switch-on">
                                          YES
                                        </div>
                                      }
                                    />
                                  </td>
                                  <td className="text-center">
                                    <Switch
                                      onChange={(e) => {
                                        change(val._id, e, "status", id);
                                      }}
                                      checked={val.status === true}
                                      offColor="#C8C8C8"
                                      onColor="#0093ed"
                                      height={30}
                                      width={70}
                                      className="react-switch"
                                      uncheckedIcon={
                                        <div className="react-switch-off">
                                          OFF
                                        </div>
                                      }
                                      checkedIcon={
                                        <div className="react-switch-on">
                                          ON
                                        </div>
                                      }
                                    />
                                  </td>
                                  <td className="text-center">
                                    <Link to={`/wallpaper/view/${val._id}`}>
                                      <Button
                                        variant="outline-warning"
                                        size="sm"
                                        className="me-2 btn-icon"
                                      >
                                        <i className="bx bx-show"></i>
                                      </Button>
                                    </Link>
                                    <Link to={`/wallpaper/edit/${val._id}`}>
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        className="me-2 btn-icon"
                                      >
                                        <i className="bx bx-edit"></i>
                                      </Button>
                                    </Link>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="btn-icon"
                                      onClick={() => deleteWallpaper(val._id)}
                                    >
                                      <i className="bx bx-trash-alt" />
                                    </Button>
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                        </tbody>
                      )}
                    </Droppable>
                    {wallpaperData.length === 0 ? (
                      <tbody>
                        <tr>
                          <td colSpan="100%" className="p-0">
                            <div className="no-found">
                              <img
                                src="../../not-found/live-theme.svg"
                                alt="No Found Wallpaper"
                              />
                              <p>No Found Wallpaper </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      ""
                    )}
                  </Table>
                </DragDropContext>

                {wallpaperData.length > size ? (
                  <div className="pagination-custom">
                    <Pagination
                      className="pagination-wallpaperData"
                      onChange={PaginationChange}
                      total={wallpaperData.length}
                      current={current}
                      pageSize={size}
                      showSizeChanger={false}
                      itemRender={PrevNextArrow}
                      showTitle={false}
                    />
                  </div>
                ) : (
                  ""
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default Wallpaper;
